import {
  Box,
  Field as ChakraField,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  InputGroup,
} from "@chakra-ui/react";
import { useState, FC, ReactElement, ReactNode } from "react";
import { Field } from "formik";

import { ViewIcon, ViewOffIcon } from "@shared/components/Icons";

import "./index.scss";

interface InputProps extends ChakraInputProps {
  label?: ReactNode;
  isShowPasswordIcon?: boolean;
  inputLeftElement?: ReactElement;
  inputRightElement?: ReactElement;
  showValidCheckmark?: boolean;
  isRequiredField?: boolean;
  helpText?: string;
  formControlProps?: ChakraField.RootProps;
}

const Input: FC<InputProps> = ({
  label,
  isShowPasswordIcon,
  inputLeftElement,
  inputRightElement,
  showValidCheckmark,
  isRequiredField,
  helpText,
  formControlProps,
  ...inputProps
}) => {
  const [isShowPassword, setShowPassword] = useState(false);

  const endElement = isShowPasswordIcon ? (
    <Box
      cursor="pointer"
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={() => setShowPassword(!isShowPassword)}
    >
      {!isShowPassword ? <ViewOffIcon color="brand.white" /> : <ViewIcon color="brand.white" />}
    </Box>
  ) : inputRightElement && (showValidCheckmark === undefined || showValidCheckmark) ? (
    inputRightElement
  ) : undefined;

  const elementProps = { px: 0, fontSize: "md", color: "inherit" };

  return (
    <ChakraField.Root
      required={isRequiredField}
      // v3's input takes `disabled` from the field context, not from its own prop.
      disabled={inputProps.disabled}
      mt={4}
      className="input"
      {...formControlProps}
    >
      {label && (
        <ChakraField.Label>
          {label}
          <ChakraField.RequiredIndicator />
        </ChakraField.Label>
      )}
      <InputGroup
        startElement={inputLeftElement}
        startElementProps={{ ...elementProps, w: "35px" }}
        endElement={endElement}
        endElementProps={{ ...elementProps, w: isShowPasswordIcon ? "40px" : "35px" }}
      >
        <Field
          as={ChakraInput}
          _focusVisible={{ boxShadow: "transparent" }}
          variant="outline"
          bg="brand.white"
          borderRadius="base"
          {...inputProps}
          type={isShowPassword ? "text" : inputProps.type}
        />
      </InputGroup>
      {helpText && <ChakraField.HelperText>{helpText}</ChakraField.HelperText>}
    </ChakraField.Root>
  );
};

export default Input;
